import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(
        'https://api.thechamps.app/email/newsletter',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email,
            referrer: window.location.href,
          }),
        }
      );

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (err) {
      setSubmitStatus('error');
    }

    setIsSubmitting(false);
  };

  return (
    <section className='py-20 bg-secondary text-white'>
      <div className='container mx-auto px-4 max-w-4xl'>
        <div className='text-center mb-12'>
          <h2 className='text-3xl md:text-4xl font-bold mb-4'>
            Stay Updated with <span className='text-accent'>TheChamps</span>
          </h2>
          <p className='text-lg text-text-submain max-w-2xl mx-auto'>
            Subscribe to our newsletter for the latest fitness tips, app
            updates, and exclusive content to help you on your fitness journey.
          </p>
        </div>

        <div className='bg-primary rounded-xl p-8 shadow-lg border border-tertiary'>
          <div className='flex flex-col items-center justify-between gap-6'>
            <div className='flex-1 w-full'>
              <h3 className='text-xl font-semibold mb-2'>Join Our Community</h3>
              <p className='text-text-submain'>
                Get insights, motivation, and tips delivered straight to your
                inbox.
              </p>
            </div>
            <form
              onSubmit={handleSubmit}
              className='flex flex-col sm:flex-row gap-3 w-full'
            >
              <input
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder='Your email address'
                className='px-4 py-3 bg-tertiary border border-tertiary rounded-md focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent flex-1 min-w-[250px]'
                disabled={isSubmitting}
              />
              <button
                type='submit'
                className='bg-accent hover:bg-accentHover text-black font-bold py-3 px-6 rounded-md transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed'
                disabled={isSubmitting || !email}
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe Now'}
              </button>
            </form>
          </div>
          {submitStatus === 'success' && (
            <div className='mt-4 text-center text-green-500'>
              Thanks for subscribing! Check your inbox for updates.
            </div>
          )}
          {submitStatus === 'error' && (
            <div className='mt-4 text-center text-red-500'>
              Oops! Something went wrong. Please try again later.
            </div>
          )}
          <p className='text-text-submain text-sm mt-4 text-center'>
            By subscribing, you agree to our Privacy Policy and consent to
            receive updates from our company.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
